module.exports = require("./uz-Cyrl.js");